import { render, staticRenderFns } from "./TicketChat.vue?vue&type=template&id=39b250f8&"
import script from "./TicketChat.vue?vue&type=script&lang=ts&"
export * from "./TicketChat.vue?vue&type=script&lang=ts&"
import style0 from "./TicketChat.vue?vue&type=style&index=0&id=39b250f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports